export default "__VITE_ASSET__CVVsouv5__"